var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "f16-flight.7465e858.png","uri@2x": __webpack_public_path__ + "f16-flight.c1b28006.png","uri@3x": __webpack_public_path__ + "f16-flight.c54cf449.png",
    width: 368,
    height: 61
});